var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-flex tw-justify-between tw-gap-4 tw-text-[#1f2229] tw-overflow-x-hidden"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }